'use client';

import useSWR from 'swr';
import { useClubSlug } from '~/components/Clubs/hooks';
import { bankingKeys } from '../api';
import { BankAccount } from '../types';

interface UseBankAccountsResult {
    data: BankAccount[];
    isLoading: boolean;
    error: unknown;
    mutate: () => void;
}

export const useBankAccounts = (): UseBankAccountsResult => {
    const clubSlug = useClubSlug();
    const key = clubSlug ? bankingKeys.accounts(clubSlug) : null;

    const { data, isLoading, error, mutate } = useSWR<{ data: BankAccount[] }>(key);

    return {
        data: data?.data ?? [],
        isLoading,
        error,
        mutate,
    };
};
